var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 .34 1.78 4.893l4.553 1.22-1.25-2.165a5.84 5.84 0 0 1 7.969 2.135 5.8 5.8 0 0 1 .702 1.997l1.724.46a7.44 7.44 0 0 0-.983-3.29C12.428 1.669 7.832.437 4.25 2.505zM.522 9.459a7.44 7.44 0 0 0 .983 3.291c2.067 3.581 6.663 4.813 10.245 2.745L13 17.66l1.22-4.553-4.553-1.22 1.25 2.165a5.84 5.84 0 0 1-7.969-2.135 5.8 5.8 0 0 1-.702-1.997z"
  })));
};
export default SvgRotate;